import { createSlice } from '@reduxjs/toolkit'
import {getProvinces} from "./thunks"
import { logOut } from '../authentication/authenticationSlice';

const initialState= { 
  provinces: {
  }, 
  loading: "idle",
  error: null }

const provinceSlice = createSlice({
  name: 'provinces',
  initialState,
  reducers: {
    clearProvinceError: (state)=>{
      state.error = null
      state.loading = "idle"
    }
  },
  extraReducers: {
    [getProvinces.pending]: (state) => {
        state.loading = "loading"; 
        state.error = null
      },
    [getProvinces.fulfilled]: (state, action) => {
    state.loading = "succeeded";
    state.provinces = action.payload
      
    },
    [getProvinces.rejected]: (state, action) => {
        state.loading = "failed"; 
        state.error = action.error.message
      },
    [logOut]: (state)=> initialState
  }
})

export const {clearProvinceError} = provinceSlice.actions;
export default provinceSlice.reducer
